import React, { useState, useEffect, Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { OutlinedInput, FormControl } from '@material-ui/core';
import { TopTextReusableComponent } from '../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from '../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
//import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from '../../../../../../../../store/validation/is-Empty';
import SuggestNewButton from '../../../../../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton';
import { update_item_menu_setup } from '../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';

const Tags = (props) => {
  const back = () => {
    props.onChange(1);
    window.scroll(0, 0);
  };

  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    if (
      props.menuCategoryItems.currentState !== 9 ||
      props.menuCategoryItems.runingTrack !== 9
    ) {
      formData.currentState = 1;
      formData.runingTrack = 1;
    }
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };

  const [tags, setTags] = useState([]);
  const [healthTags, setHealthTags] = useState([]);

  const validate = (values) => {
    const errors = {};

    // if (values.tags.length === 0) {
    //   errors.tags = "Please select tag";
    // }

    // if (values.tags.length > 0 && values.primary_tag.length == 0) {
    //   errors.primary_tag = "Please select primary tag";
    // }

    return errors;
  };

  const removeTag = (id) => {
    if (formik.values.primary_tag.length > 0) {
      if (formik.values.primary_tag[0] === id) {
        formik.setFieldValue('primary_tag', []);
      }
    }
    let data = formik.values.tags;
    data = data.filter((item) => {
      return item !== id;
    });
    formik.setFieldValue('tags', data);
  };

  const onClickAddTag = (itemId) => {
    let data = formik.values.tags;
    //let updateState = [];

    // for (let i = 0; i < tags.length; i++) {
    //   if (tags[i].title !== itemName) {
    //     updateState.push(tags[i])
    //   }
    // }
    // setTags(updateState);

    if (data.includes(itemId)) {
      alert('Item already added');
    } else {
      data.push(itemId);
    }
    if (
      typeof data != 'undefined' &&
      data != null &&
      data.length != null &&
      data.length === 1
    ) {
      formik.setFieldValue('tags', data);
      formik.setFieldValue('primary_tag[0]', itemId);
    } else {
      formik.setFieldValue('tags', data);
    }
  };

  const setPrimaryTag = (id) => {
    formik.setFieldValue('primary_tag[0]', id);
  };

  /*************************************
   * @DESC Health Tags Action
   *************************************/
  const onClickAddHealthTag = (itemId) => {
    let data = formik.values?.healthTags;
    if (data.includes(itemId)) {
      alert('Item already added');
    } else {
      data.push(itemId);
    }
    if (
      typeof data != 'undefined' &&
      data != null &&
      data.length != null &&
      data.length === 1
    ) {
      formik.setFieldValue('healthTags', data);
      formik.setFieldValue('primary_health_tag[0]', itemId);
    } else {
      formik.setFieldValue('healthTags', data);
    }
  };
  const setPrimaryHealthTag = (id) => {
    formik.setFieldValue('primary_health_tag[0]', id);
  };
  const removeHealthTag = (id) => {
    if (formik.values.primary_health_tag.length > 0) {
      if (formik.values.primary_health_tag[0] === id) {
        formik.setFieldValue('primary_health_tag', []);
      }
    }
    let data = formik.values.healthTags;
    data = data.filter((item) => {
      return item !== id;
    });
    formik.setFieldValue('healthTags', data);
  };

  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  const onSuccess = () => {
    if (props.activeItemData.productClassification === 'Non-Food') {
      console.log('change5');
      props.onChange(5);
    } else {
      if (props?.personalization_information) {
        props.onChange(3);
      } else if (props?.allergic_information) {
        props.onChange(4);
      } else {
        props.onChange(5);
      }
    }

    window.scroll(0, 0);
  };

  const formik = useFormik({
    initialValues: {
      tags: [],
      primary_tag: [],
      healthTags: [],
      primary_health_tag: [],
    },
    validate,

    onSubmit: (values) => {
      let formData = {};
      // formData = { ...formik.values };
      formData.healthTags = values?.healthTags;
      formData.primary_health_tag = values?.primary_health_tag[0]
        ? values?.primary_health_tag[0]
        : values?.primary_health_tag;
      formData.tags = values?.tags;
      formData.primary_tag = values?.primary_tag;
      if (props.activeItemData.productClassification === 'Non-Food') {
        delete formData.healthTags;
        delete formData.primary_health_tag;
      }

      const token = props.auth.user.accessToken;
      if (
        props.menuCategoryItems.currentState !== 9 ||
        props.menuCategoryItems.runingTrack !== 9
      ) {
        formData.currentState = 2;
        formData.runingTrack = 3;
      }
      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.healthTagsInfo?.length; i++) {
      if (props.healthTagsInfo[i].status === 'APPROVED') {
        data.push({
          id: props.healthTagsInfo[i]._id,
          title: props.healthTagsInfo[i].title,
        });
      }
    }
    setHealthTags(data);
  }, [props.healthTagsInfo]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.tags_info.length; i++) {
      if (props.tags_info[i].status === 'APPROVED') {
        data.push({
          id: props.tags_info[i]._id,
          title: props.tags_info[i].title,
        });
      }
    }
    setTags(data);
  }, [props.tags_info]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      formik.setFieldValue('tags', data.tags);
      formik.setFieldValue('primary_tag', data.primary_tag);
      formik.setFieldValue(
        'healthTags',
        data.healthTags !== undefined && data.healthTags !== null
          ? data.healthTags
          : []
      );
      formik.setFieldValue(
        'primary_health_tag',
        data.primary_health_tag !== undefined &&
          data.primary_health_tag !== null
          ? data.primary_health_tag
          : []
      );
      // let stateTagData = [];
      // for (let i = 0; i < tags.length; i++) {
      //   if (!data.tags.includes(tags[i].title)) {
      //     stateTagData.push({ title: tags[i].title });
      //   }
      // }
      // setTags(stateTagData);
    }
  }, [props.menuCategoryItems]);

  return (
    <React.Fragment>
      <Form>
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={'w-100 bg-white'} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        <div className="f14-700 mb-3">
          Select Item Tag under which Item to be displayed
        </div>
        <div className="restaurant_type_onboarding_main smallCenter">
          <div className="cuisine-main mt-0">
            <div
              className={
                // state.all_food_type.length > 8
                //   ?
                'cuisine-main-padding-border'
                //   : ""
              }
            >
              <div
                id="box-style"
                className="cuisine-main-padding column-2 justify-content-start"
                style={{ display: 'flex', flexWrap: 'wrap' }}
              >
                {tags.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    // classsection={
                    //   state.selected_food_type.includes(icon)
                    //     ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                    //     : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                    // }
                    classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                    src={icon.icon}
                    title={icon.title}
                    //onClick={onRestaurantFoodTypeArraySelector(icon, index)}
                    onClick={() => onClickAddTag(icon.id)}
                  />
                ))}
                {/* <AddButtonIconComponent
                  buttonText="Suggest New"
                  fontIcon="fa fa-plus"
                  colorCss="red"
                /> */}
              </div>
              {formik.errors.tags && formik.touched.tags ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.tags}
                </div>
              ) : null}
            </div>
            <div className="suggest-button-heading">
              <SuggestNewButton categoryId={'5ffd80985ff032513b1353a2'} />
            </div>
            <hr />
            {formik.values.tags.length > 0 ? (
              <div className="f14-700 mb-3 mt-4">
                Out Of The Ones You Selected, Which One Is Primary?
              </div>
            ) : (
              <> </>
            )}
            <div
              className="cuisine-main-padding-bottom column-2 justify-content-start mobile-device-bottom-margin mt-4"
              style={{ display: 'flex', flexWrap: 'wrap' }}
            >
              {tags.map((icon, index) => (
                <Fragment>
                  {formik.values.tags.includes(icon.id) ? (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection={
                        formik.values.primary_tag[0] === icon.id
                          ? 'onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type'
                          : 'onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active'
                      }
                      src={icon.icon}
                      title={icon.title}
                      onClick={() => setPrimaryTag(icon.id)}
                      displayPrimary={
                        formik.values.primary_tag[0] === icon.id ? true : false
                      }
                      displayRemove={true}
                      removeButtonClick={() => removeTag(icon.id)}
                    />
                  ) : (
                    <> </>
                  )}
                </Fragment>
              ))}
            </div>
            {formik.errors.primary_tag && formik.touched.primary_tag ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.primary_tag}
              </div>
            ) : null}
          </div>
        </div>
        {props.activeItemData.productClassification === 'Non-Food' ? null : (
          <>
            <div className="f14-700 mb-3">
              Select Health Tag for the item under which Item to be displayed
            </div>
            <div className="restaurant_type_onboarding_main smallCenter">
              <div className="cuisine-main mt-0">
                <div
                  className={
                    // state.all_food_type.length > 8
                    //   ?
                    'cuisine-main-padding-border'
                    //   : ""
                  }
                >
                  <div
                    id="box-style"
                    className="cuisine-main-padding column-2 justify-content-start"
                    style={{ display: 'flex', flexWrap: 'wrap' }}
                  >
                    {!isEmpty(healthTags) &&
                      healthTags.map((icon, index) => (
                        <ReusableOnboardingMapButton
                          key={index}
                          // classsection={
                          //   state.selected_food_type.includes(icon)
                          //     ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                          //     : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          // }
                          classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          src={icon.icon}
                          title={icon.title}
                          //onClick={onRestaurantFoodTypeArraySelector(icon, index)}
                          onClick={() => onClickAddHealthTag(icon.id)}
                        />
                      ))}
                    {/* <AddButtonIconComponent
                  buttonText="Suggest New"
                  fontIcon="fa fa-plus"
                  colorCss="red"
                /> */}
                  </div>
                  {formik.errors.healthTags && formik.touched.healthTags ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.healthTags}
                    </div>
                  ) : null}
                </div>
                <div className="suggest-button-heading">
                  <SuggestNewButton categoryId={'6204d2c756deb559e7df52b5'} />
                </div>
                <hr />
                {formik.values.healthTags.length > 0 ? (
                  <div className="f14-700 mb-3 mt-4">
                    Out of the ones you selected, which one is Primary?
                  </div>
                ) : (
                  <> </>
                )}
                <div
                  className="cuisine-main-padding-bottom column-2 justify-content-start mobile-device-bottom-margin mt-4"
                  style={{ display: 'flex', flexWrap: 'wrap' }}
                >
                  {!isEmpty(healthTags) &&
                    healthTags.map((icon, index) => (
                      <Fragment>
                        {formik.values.healthTags.includes(icon.id) ? (
                          <ReusableOnboardingMapButton
                            key={index}
                            classsection={
                              formik.values.primary_health_tag[0] === icon.id
                                ? 'onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type'
                                : 'onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active'
                            }
                            src={icon.icon}
                            title={icon.title}
                            onClick={() => setPrimaryHealthTag(icon.id)}
                            displayPrimary={
                              formik.values.primary_health_tag[0] === icon.id
                                ? true
                                : false
                            }
                            displayRemove={true}
                            removeButtonClick={() => removeHealthTag(icon.id)}
                          />
                        ) : (
                          <> </>
                        )}
                      </Fragment>
                    ))}
                </div>
                {formik.errors.primary_health_tag &&
                formik.touched.primary_health_tag ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.primary_health_tag}
                  </div>
                ) : null}
              </div>
            </div>
          </>
        )}

        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            //onClick={onSubmit}
            onClick={(e) => onClickNext(e)}
          />
        </div>
      </Form>
    </React.Fragment>
  );
};

Tags.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  tags_info: state.category && state.category.tags_info,
  healthTagsInfo: state?.category && state?.category?.health_tags,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
  personalization_information:
    state.onboarding.restaurantDetails.personalization_information,
  allergic_information: state.onboarding.restaurantDetails.allergic_information,
  activeItemData: state.onboarding && state.onboarding.activeItemIdata,
});

export default connect(mapStateToProps, { update_item_menu_setup })(Tags);
